import LearningObjectives from "./learning_objectives";
export default LearningObjectives;